export function toEnglishNumber(str, preserveOtherChars = true, canBeNegative = false, preserveDot = false) {
    let result = ""
    for (let i = 0; i < str.length; i++) {
        const c = str[i];
        if ((i === 0) && (canBeNegative) && (c === "-")) {
            result += "-"
        }
        if (c === "۰") {
            result += "0"
        } else if (c === "۱") {
            result += "1"
        } else if (c === "۲") {
            result += "2"
        } else if (c === "۳") {
            result += "3"
        } else if (c === "۴") {
            result += "4"
        } else if (c === "۵") {
            result += "5"
        } else if (c === "۶") {
            result += "6"
        } else if (c === "۷") {
            result += "7"
        } else if (c === "۸") {
            result += "8"
        } else if (c === "۹") {
            result += "9"
            // --------------------------
        } else if (c === "٠") {
            result += "0"
        } else if (c === "١") {
            result += "1"
        } else if (c === "٢") {
            result += "2"
        } else if (c === "٣") {
            result += "3"
        } else if (c === "٤") {
            result += "4"
        } else if (c === "٥") {
            result += "5"
        } else if (c === "٦") {
            result += "6"
        } else if (c === "٧") {
            result += "7"
        } else if (c === "٨") {
            result += "8"
        } else if (c === "٩") {
            result += "9"
            // --------------------------
        } else {
            switch (c) {
                case "0":
                case "1":
                case "2":
                case "3":
                case "4":
                case "5":
                case "6":
                case "7":
                case "8":
                case "9":
                    result += c;
                    break;
                case ".":
                    if (preserveDot || preserveOtherChars) {
                        result += c;
                    }
                    break;
                default:
                    if (preserveOtherChars) {
                        result += c;
                    }
                    break;
            }
        }
    }
    return result
}

export function toPersianNumber(str, preserveOtherChars = true) {
    let result = ""
    for (let i = 0; i < str.length; i++) {
        const c = str[i];
        switch (c) {
            case "0":
                result += "۰";
                break;
            case "1":
                result += "۱";
                break;
            case "2":
                result += "۲";
                break;
            case "3":
                result += "۳";
                break;
            case "4":
                result += "۴";
                break;
            case "5":
                result += "۵";
                break;
            case "6":
                result += "۶";
                break;
            case "7":
                result += "۷";
                break;
            case "8":
                result += "۸";
                break;
            case "9":
                result += "۹";
                break;
            default:
                if (preserveOtherChars) {
                    result += c;
                }
                break;
        }
    }
    return result
}

export function toArabicNumber(str, preserveOtherChars = true) {
    let result = "";
    for (let i = 0; i < str.length; i++) {
        const c = str[i];
        switch (c) {
            case "0":
                result += "٠";
                break;
            case "1":
                result += "١";
                break;
            case "2":
                result += "٢";
                break;
            case "3":
                result += "٣";
                break;
            case "4":
                result += "٤";
                break;
            case "5":
                result += "٥";
                break;
            case "6":
                result += "٦";
                break;
            case "7":
                result += "٧";
                break;
            case "8":
                result += "٨";
                break;
            case "9":
                result += "٩";
                break;
            default:
                if (preserveOtherChars) {
                    result += c;
                }
                break;
        }
    }
    return result;
}

export function cleanPhoneNumber(value) {
    const n = toEnglishNumber(String(value).replace(/ /g, ''));
    if (n.length > 10) {
        return n.substring(0, 10);
    } else {
        return n;
    }
}

export function markupPhoneNumber(value) {
    let num = cleanPhoneNumber(value);
    if (num === "0") {
        num = "";
    }
    if (num.length > 3) {
        num = num.substring(0, 3) + ' ' + num.substring(3);
    }
    if (num.length > 7) {
        num = num.substring(0, 7) + ' ' + num.substring(7);
    }
    // if (num.length > 12) {
    //     num = num.substring(0, 12);
    // }
    return num;
}

export function isValidMobilePhoneNumber(countryCode, phoneNumber) {
    switch (countryCode) {
        case "98":
        case "964":
            return phoneNumber.length === 10
        case "000":
            return phoneNumber.length === 9
        default:
            return false;
    }
}

// export function markupPhoneNumber(value) {
//     let num = toEnglishNumber(String(value).replace(/ /g, ''));
//         if (num === "0") {
//         return "";
//     }
//     let formattedNum = '';
//     if (num.length <= 4) {
//         // Less than or equal to 4 characters, return as is
//         formattedNum = num;
//     } else if (num.length <= 7) {
//         // If between 5 to 7 characters, add a space before the last 4
//         formattedNum = num.slice(0, -4) + ' ' + num.slice(-4);
//     } else {
//         // More than 7 characters
//         formattedNum = num.slice(0, -7) + ' ' + num.slice(-7, -4) + ' ' + num.slice(-4);
//     }
//     return formattedNum;
// }


// +98 912 3** **89
export function markupMobilePhoneNumberWithCountryCode(num) {
    if (num.startsWith("+98")) {
        return num.substring(0, 3) + ' ' +
            num.substring(3, 6) + ' ' +
            num.substring(6, 9) + ' ' +
            num.substring(9);
    } else if (num.startsWith("+964")) {
        return num.substring(0, 4) + ' ' +
            num.substring(4, 7) + ' ' +
            num.substring(7, 10) + ' ' +
            num.substring(10);
    } else {
        return num;
    }
}

export function fixRedactedPhoneNumberForRTLText(pn) {
    if (pn) {
        let spn = pn.split("****")
        if (spn.length === 2) {
            return spn[1] + "****" + spn[0]
        }
    }
    return pn
}
